import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './config/authConfig';
import { AuthProvider } from './contexts/AuthContext';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import GMUDList from './pages/GMUDList';
import GMUDCreate from './pages/GMUDCreate';
import GMUDEdit from './pages/GMUDEdit';
import GMUDView from './pages/GMUDView';
import EmailRedirect from './pages/EmailRedirect';
import AprovadoresList from './pages/AprovadoresList';
import AprovadorCreate from './pages/AprovadorCreate';
import AprovadorEdit from './pages/AprovadorEdit';
import Relatorios from './pages/Relatorios';
import Auditoria from './pages/Auditoria';
import Configuracoes from './pages/Configuracoes';

// Inicializar MSAL
const msalInstance = new PublicClientApplication(msalConfig);

function App() {
  return (
    <MsalProvider instance={msalInstance}>
      <AuthProvider>
        <Routes>
          <Route path='/login' element={<Login />} />
          <Route path='/email-redirect/:id' element={<EmailRedirect />} />
          <Route
            path='/*'
            element={
              <ProtectedRoute>
                <Layout>
                  <Routes>
                    <Route path='/' element={<Dashboard />} />
                    <Route path='/gmuds' element={<GMUDList />} />
                    <Route path='/gmuds/novo' element={<GMUDCreate />} />
                    <Route path='/gmuds/:id' element={<GMUDView />} />
                    <Route path='/gmuds/:id/editar' element={<GMUDEdit />} />
                    <Route path='/aprovadores' element={<AprovadoresList />} />
                    <Route path='/aprovadores/novo' element={<AprovadorCreate />} />
                    <Route path='/aprovadores/:id/editar' element={<AprovadorEdit />} />
                    <Route path='/relatorios' element={<Relatorios />} />
                    <Route path='/auditoria' element={<Auditoria />} />
                    <Route path='/configuracoes' element={<Configuracoes />} />
                  </Routes>
                </Layout>
              </ProtectedRoute>
            }
          />
        </Routes>
      </AuthProvider>
    </MsalProvider>
  );
}

export default App;
